import tw from "twin.macro";

export const SectionHeading = tw.h2`text-3xl md:text-4xl xl:text-5xl font-black text-primary-800 uppercase text-center leading-none font-sans`;
export const Subheading = tw.h5`font-bold uppercase text-primary-500 font-display`;
